export default __webpack_public_path__ + "static/media/Achievements4.f8d2ba04.webp";